/**
 * XPath selectors for the Google Profile Photo automation.
 *
 * Extracted into a standalone module so they can be imported by both
 * production code (googleProfilePhoto.ts) and Playwright E2E tests
 * without pulling in runtime dependencies that reference `window`.
 */

export const XPATHS = {
  profilePicButton:
    '//div[@aria-label="Change profile photo"]//button' +
    ' | //div[@aria-label="Profile photo"]//button',
  iframe: '//iframe[contains(@src, "/profile-picture")]',
  visibilityButton: '//button[@aria-label="Profile picture visibility"]',
  // Uses contains(., "Anyone") instead of exact matching because Google
  // prepends non-breaking spaces (U+00A0) to option text.
  anyoneRadio:
    '//div[@role="radiogroup"]/div[contains(., "Anyone")]//*[@role="radio"]' +
    ' | //div[@role="radiogroup"]/div[contains(., "Anyone")]//input[@type="radio"]',
  radiogroup: '//div[@role="radiogroup"]',
  saveButton: '//button[normalize-space()="Save"]',
  cancelButton: '//button[normalize-space()="Cancel"]',
}

export function getVisibilityTargetXpath(
  value: 'anyone' | 'people_you_interact_with',
): string {
  const rowPredicate =
    value === 'anyone' ? 'contains(., "Anyone")' : 'not(contains(., "Anyone"))'
  return (
    `//div[@role="radiogroup"]/div[${rowPredicate}]//*[@role="radio"]` +
    ` | //div[@role="radiogroup"]/div[${rowPredicate}]//label`
  )
}
